import {
  getTherapy,
  IDuration,
  IServiceOrder,
  IServiceTask,
  IServiceTaskDocumentation,
  ServiceTaskStatus,
} from '@alberta/konexi-shared';
import { ignore } from '@common/tracking/tracker';
import { BaseViewModel } from '@common/viewmodel/base-view-model';
import { TherapyItem } from 'src/app/shared/models/therapy-item';
import { ServiceOrderedServiceLineViewModel } from '../../service-order-entity/view-model/service-ordered-service-line-view-model';

export class ServiceTaskViewModel extends BaseViewModel implements IServiceTask {
  serviceId: string;
  selectedTaskOption?: 'default' | 'firstTask' | string;
  documentation?: IServiceTaskDocumentation;
  cancellationReason: string;
  description: string;
  status: ServiceTaskStatus;
  patientId: string;
  regionId: string;
  therapyId: number;
  therapyTypeId: number;
  woundLocation: number;
  additionalLocations?: string[];
  appointmentId: string;
  integratedCareId: string;
  duration: IDuration;
  annotation: string;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
  demandId?: string;
  location?: number[];
  seriesAppointmentId?: string;

  @ignore()
  therapyName: string;
  @ignore()
  therapyTypeName: string;

  @ignore()
  therapyIcon: string;

  public static from(
    serviceOrder: IServiceOrder,
    serviceLineViewModel: ServiceOrderedServiceLineViewModel,
    taskOption: 'default' | 'firstTask' | string,
    appointmentId?: string,
    withoutAppointment?: boolean
  ): ServiceTaskViewModel {
    const serviceTask = new ServiceTaskViewModel();
    serviceTask.serviceId = serviceLineViewModel.serviceId;
    serviceTask.patientId = serviceOrder.patientId;
    serviceTask.therapyId = serviceOrder.therapyId;
    serviceTask.therapyTypeId = serviceOrder.therapyTypeId;
    serviceTask.status = withoutAppointment ? ServiceTaskStatus.ToPlan : ServiceTaskStatus.ToDocument;
    serviceTask.integratedCareId = serviceOrder.integratedCareId;
    serviceTask.woundLocation = serviceOrder.woundLocation;
    serviceTask.additionalLocations = serviceOrder.additionalLocations;
    serviceTask.regionId = serviceOrder.regionId;
    serviceTask.duration = serviceLineViewModel.dosage.duration;
    if (serviceLineViewModel.service.taskOptions[taskOption]) {
      serviceTask.selectedTaskOption = taskOption;
      serviceTask.description = serviceLineViewModel.service.taskOptions[taskOption].title;
    } else {
      serviceTask.selectedTaskOption = 'default';
      serviceTask.description = serviceLineViewModel.service.taskOptions.default?.title;
    }
    if (appointmentId) {
      serviceTask.appointmentId = appointmentId;
    }
    serviceTask.initialize();
    return serviceTask;
  }

  public initialize() {
    const therapyItem = getTherapy(this.therapyId);
    if (therapyItem) {
      this.initializeTherapy(therapyItem);
    }
  }

  private initializeTherapy(therapyItem: TherapyItem) {
    this.therapyIcon = therapyItem.iconName;
    const therapyType = therapyItem.therapyTypes.find(type => type.id === this.therapyTypeId);
    const therapyTypeName = therapyType ? therapyType.displayName : 'ohne Therapieart';
    this.therapyName = therapyItem.displayName;
    this.therapyTypeName = therapyTypeName;
  }
}
